/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export function patchModuleCompilation(): void {
  // Does nothing, but exists as a target for patching.
}



// WEBPACK FOOTER //
// ../../../../../packages/core/src/render3/jit/module_patch.ts